import React from 'react';
import { connect } from 'react-redux';
import CloseButton from '../../components/CloseButton/CloseButton';
import { IState } from '../../store/state';
import { ELedView } from '../constants';
import { getLedView } from '../selectors';
import { ExerciseActions } from '../slice';
import DecreaseDifficultyView from './DecreaseDifficultyView';
import DifficultyChangeConfirmationView from './DifficultyChangeConfirmationView';
import IncreaseDifficultyView from './IncreaseDifficultyView';
import './LedViewConatiner.scss';

export interface ILedViewConatinerProps {
  view: ELedView;
  onCancel: () => void;
}

export const LedViewConatinerFC: React.FC<ILedViewConatinerProps> = ({ view, onCancel }) => {
  if (view === ELedView.None) {
    return null;
  }
  const animationClass = view !== ELedView.Hide ? 'show' : 'hide';
  let cardContent;
  switch (view) {
    case ELedView.Confirmation:
      cardContent = <DifficultyChangeConfirmationView />;
      break;
    case ELedView.Increase:
      cardContent = <IncreaseDifficultyView />;
      break;
    case ELedView.Decrease:
      cardContent = <DecreaseDifficultyView />;
      break;
    default:
      cardContent = null;
      break;
  }
  return (
    <div className={`led-container ${animationClass}`}>
      <div className="led-card">
        {cardContent}
        <CloseButton onClick={onCancel} />
      </div>
    </div>
  );
};

export const mapStateToProps = (state: IState) => {
  const view = getLedView(state);
  return {
    view,
  };
};

export const mapDispatchToProps = {
  onCancel: ExerciseActions.cancelDifficulty,
};

const LedViewConatiner = connect(mapStateToProps, mapDispatchToProps)(LedViewConatinerFC);
export default LedViewConatiner;
